<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Order detail</h4>

              <div class="mb-2 rounded p-2" style="background-color: #f5f5f5">
                <router-link
                  :to="{ name: 'CustomerOrders' }"
                  class="d-inline"
                  style="font-weight: normal"
                >
                  Customer Orders
                </router-link>
                <p class="d-inline pl-1 pr-1">/</p>
                <router-link
                  :to="{}"
                  class="d-inline"
                  style="font-weight: normal"
                >
                  Order Detail
                </router-link>
                <p class="d-inline pl-1 pr-1">/</p>
                <router-link
                  :to="{}"
                  class="d-inline"
                  style="font-weight: normal"
                >
                  {{ order.orderNumber }}
                </router-link>
              </div>

              <table
                :class="
                  Loading
                    ? 'table border disable table-sm'
                    : 'table border table-sm'
                "
                style="margin: 0 auto"
              >
                <thead>
                  <tr>
                    <th colspan="2" class="pl-2 pt-2 pb-2">
                      <span class="icon-span pr-0">
                        <router-link
                          :to="{
                            name: 'DivvyAdminUsersEditUser',
                            params: { id: order.userId },
                          }"
                          ><font-awesome-icon class="icon-list" icon="user"
                        /></router-link>
                        -
                        <font-awesome-icon
                          @click="newNoteActive"
                          style="color: #1890ff; cursor: pointer"
                          class="icon-list"
                          icon="envelope"
                        />
                        -
                        <router-link
                          :to="{
                            name: 'DivvyAdminUsersReportUser',
                            params: { id: order.userId },
                          }"
                          ><font-awesome-icon class="icon-list" icon="file-alt"
                        /></router-link>
                        -
                      </span>
                      <span class="text-span pl-0">
                        [<router-link
                          :to="{
                            name: 'faxComponent',
                            query: { orderId: order.orderNumber },
                          }"
                          target="_blank"
                          ><span>Fax</span></router-link
                        >] - [<router-link
                          :to="{
                            name: 'faxComponent',
                            query: {
                              orderId: order.orderNumber,
                              isEmail: true,
                            },
                          }"
                          target="_blank"
                          ><span>Email order</span></router-link
                        >] - [<router-link :to="{ name: '' }"
                          ><span>Login here</span></router-link
                        >]
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- First Row Start-->
                  <UserInfo />
                  <!-- First Row End-->

                  <!-- Second Row Start -->
                  <tr class="d-flex p-2">
                    <td class="mr-1 p-zero" style="width: 33.3%">
                      <div class="d-flex" style="flex-direction: column">
                        <OrderContactInfo />
                        <GiftCard />
                      </div>
                    </td>
                    <td class="ml-1 mr-1 p-zero" style="width: 33.3%">
                      <div class="d-flex" style="flex-direction: column">
                        <Item />
                        <Shipping />
                      </div>
                    </td>
                    <td class="ml-1 p-zero" style="width: 33.3%">
                      <div class="d-flex" style="flex-direction: column">
                        <div
                          :class="LoadingForStatus ? 'disable' : ''"
                          style="position: relative"
                        >
                          <OrderStatus />
                          <QualityStatus />
                          <MasterStatus />
                          <div
                            class="centered-spinner-1"
                            v-if="LoadingForStatus"
                          >
                            <a-spin />
                          </div>
                        </div>

                        <div class="border rounded p-2" style="width: 100%">
                          <button
                            type="button"
                            class="btn btn-danger d-block"
                            style="color: white; margin: 0 auto"
                            @click="submit"
                          >
                            Update All
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- Second Row End -->

              <!-- Third Row Start -->
              <InvoiceTable />
              <!-- Third Row End -->

              <div class="mb-3">
                <CurrentNotes />
              </div>

              <div v-if="Loading === true">
                <div class="centered-spinner">
                  <a-spin />
                </div>
              </div>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!-- <Footer /> -->
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
// first row
import UserInfo from "./CustomerOrderDetailsFirstRow/UserInfo.vue";
// second row
import OrderContactInfo from "./CustomerOrderDetailsSecondRow/OrderContactInfo.vue";
import Item from "./CustomerOrderDetailsSecondRow/Item.vue";
import OrderStatus from "./CustomerOrderDetailsSecondRow/OrderStatus.vue";
import GiftCard from "./CustomerOrderDetailsSecondRow/GiftCard.vue";
import MasterStatus from "./CustomerOrderDetailsSecondRow/MasterStatus.vue";
import QualityStatus from "./CustomerOrderDetailsSecondRow/QualityStatus.vue";
import Shipping from "./CustomerOrderDetailsSecondRow/Shipping.vue";
// third row
import InvoiceTable from "./CustomerOrderDetailsThirdRow/InvoiceTable.vue";
// CurrentNotes
import CurrentNotes from "./CurrentNotes/CurrentNotes.vue";

import { UTCToLocale, localeToUTC } from "@/utilities/date.js";
import moment from "moment";

export default {
  name: "CustomerOrderDetail",
  data() {
    return {
      Loading: false,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
    UserInfo,
    OrderContactInfo,
    Item,
    OrderStatus,
    GiftCard,
    MasterStatus,
    QualityStatus,
    Shipping,
    InvoiceTable,
    CurrentNotes,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "customerOrders",
        activeMenu: this.activeMenu ? this.activeMenu : "crm-tools",
      });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    submit() {
      this.Loading = true;
      const payload = {
        orderId: this.order.orderId,

        // order address request
        firstName: this.order.firstName,
        lastName: this.order.lastName,
        coname: this.order.coname,
        address1: this.order.address1,
        address2: this.order.address2,
        city: this.order.city,
        state: this.order.state,
        zip: this.order.zip,
        dayphone: this.order.dayphone,
        eveningphone: this.order.eveningphone,
        email: this.order.email,

        // gift card request
        gift: this.order.gift,
        firstName: this.order.userFirstname,
        lastName: this.order.userLastname,
        signature: this.order.signature,
        message: this.order.message,
        gift_id: this.order.orderId,

        // order status request
        orderNumber: this.order.orderNumber,
        callTag: this.order.callTag !== "0" ? true : false,
        nla: this.order.nla,
        labelReq: this.order.labelReq,
        labelReqDate:
          this.order.labelReqDate !== "" && this.order.labelReqDate !== null
            ? this.order.labelReqDate
            : "",
        replaceReq: this.order.replaceReq,
        backordered: this.order.backordered,
        followup: this.order.followup === true ? 1 : 0,
        dateProcessed:
          this.order.dateProcessed !== "" && this.order.dateProcessed !== null
            ? moment(this.order.dateProcessed).format("YYYY-MM-DD") +
              "T00:00:00.000Z"
            : "",
        backOrderDate:
          this.order.backOrderDate !== "" && this.order.backOrderDate !== null
            ? moment(this.order.backOrderDate).format("YYYY-MM-DD") +
              "T00:00:00.000Z"
            : "",
        ret_by_name: this.order.ret_by_name,
        return_qty: this.order.quanity ? this.order.quanity : 0,
        return_reason:
          this.order.ret_reason === "-1" ? "" : this.order.ret_reason,
        ret_points: this.order.ret_points,
        points_return_by: this.order.ret_by_name,
        status: this.order.status === "-1" ? "" : this.order.status,
        orderstatus:
          this.order.masterStatus === "-1" ? "" : this.order.masterStatus,

        // shipping request
        carrierName:
          this.order.carrierName === "-1" ? "" : this.order.carrierName,
        trackingNumber: this.order.trackingNumber,
        dateShipped:
          this.order.dateShipped === "" || this.order.dateShipped === null
            ? ""
            : localeToUTC(this.order.dateShipped),
        qualityNum: this.order.qualityNum,
      };
      this.$store
        .dispatch("orderDetails/updateAll", payload)
        .then((data) => {
          alert(data);
        })
        .finally(() => {
          this.Loading = false;
        });
    },
    newNoteActive() {
      this.$store.state.orderDetails.new_note = true;
      this.$router.push({
        name: "NotesManager",
        query: {
          order_id: this.$route.query.order_id,
          note_id: -1,
        },
      });
    },
  },
  computed: {
    order() {
      return this.$store.state.orderDetails.orderData;
    },
    LoadingForStatus() {
      return this.$store.state.orderDetails.LoadingForStatus;
    },
  },
  created() {
    this.scrollToTop();
    this.setActiveMenuItem();
    this.Loading = true;
    this.$store
      .dispatch("orderDetails/getOrder", {
        orderNumber: this.$route.query.order_number,
      })
      .then(() => {
        this.Loading = false;
        try {
          this.$store.dispatch("orderDetails/getInvoices", {
            orderId: this.$route.query.order_id,
          });
          this.$store.dispatch("orderDetails/getExtraOrderInfo", {
            orderId: this.$route.query.order_id,
          });
        } catch (error) {
          console.log(error);
        }
      });
  },
  destroyed() {
    if (
      this.$route.name !== "CustomerOrders" &&
      this.$route.name !== "CustomerOrdersResult"
    ) {
      this.$store.state.customerOrders.customerOrders = null;
      this.$store.state.customerOrders.form = {
        startdate: "",
        billingcode: "",
        clientids: [],
        enddate: "",
        firstname: "",
        invoicenumber: "",
        isgift: false,
        lastname: "",
        ordernumbers: [],
        orderstatuscodes: [],
        supplierids: [],
        statuscodes: [],
        trackingnumber: "",
        username: "",
        userorderid: null,
        platform: "",
        pageNumber: 1,
        pageSize: 10,
        sortField: "ORDERDATE",
        sortOrder: "DESC",
        searchlimit: "50",
      };
      this.$store.state.customerOrders.filters = {
        list: "",
        islist: false,
        sDate: "",
        eDate: "",
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
.p-zero {
  padding: 0 !important;
}
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
}
.disable {
  opacity: 0.5;
  pointer-events: none;
}
.table-responsive {
  display: block;
  max-width: 100%;
  overflow-x: scroll;
}
.centered-spinner-1 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
